import { multiply, transpose } from "mathjs"
import geometricProps from "../solve/geometricProps"
import rotationMatrix from "../solve/rotationMatrix"

function distributedToNodalForces(qx, qy, barNodes, distributedForce) {

    var geometry = geometricProps(barNodes, distributedForce)
    var L = geometry.L

    var beta = rotationMatrix(geometry.sn, geometry.cs)
    var betaT = transpose(beta)

    var nodalForces = [qx*L/2, qy*L/2, (qy*L**2)/12, qx*L/2, qy*L/2, -(qy*L**2)/12]

    var transposedNodalForces = multiply(betaT, nodalForces)

    var node1X = transposedNodalForces[0]
    var node1Y = transposedNodalForces[1]
    var node1M = transposedNodalForces[2]
    var node2X = transposedNodalForces[3]
    var node2Y = transposedNodalForces[4]
    var node2M = transposedNodalForces[5]

    var array = nodalForces

  return ({node1X, node1Y, node1M, node2X, node2Y, node2M, array, transposedNodalForces})
}

export default distributedToNodalForces